import { Injectable } from '@angular/core'
import { CartService } from './cart.service'

@Injectable({
  providedIn: 'root'
})
export class TrackInCartService {
  constructor(protected cartService: CartService) {}

  checkIsTrackInCart(id: number): boolean {
    const tracksInCart = this.cartService.getBeats()
    return tracksInCart.some(el => el.beatId === id)
  }

  checkIsTrackWithSelectedLicenseInCart(trackId: number, licenseId: string): boolean {
    const tracksInCart = this.cartService.getBeats()
    return tracksInCart.some(t => {
      return t.beatId === trackId && t.licenseId === licenseId
    })
  }
}
